export default __webpack_public_path__ + "content/aca721fe0c29e4e3cc6a016ed12f82df.png";